<template>
  <div>
    <b-form @submit.prevent="onSubmit">
      <b-form-group id="usernameInputGroup">
        <b-input-group>
          <b-input-group-prepend is-text>
            <i class="fa fa-user-circle fa-lg fa-fw"></i>
          </b-input-group-prepend>
          <b-form-input
            id="usernameInput"
            name="user.username"
            type="text"
            maxlength="50"
            v-model.trim="user.username"
            v-validate="'required'"
            :state="!errors.has('user.username')"
            aria-describedby="usernameLiveFeedback"
            placeholder="Pseudo"
            data-vv-as="&quot;Pseudo&quot;"
            size="lg"
          />
          <b-form-invalid-feedback
            id="usernameLiveFeedback"
            v-if="errors.has('user.username')"
          >{{ errors.first('user.username') }}</b-form-invalid-feedback>
        </b-input-group>
      </b-form-group>
      <b-form-group id="firstnameInputGroup">
        <b-input-group>
          <b-input-group-prepend is-text>
            <i class="fa fa-user-circle fa-lg fa-fw"></i>
          </b-input-group-prepend>
          <b-form-input
            id="firstnameInput"
            name="user.firstname"
            type="text"
            maxlength="50"
            v-model.trim="user.firstname"
            v-validate="'required'"
            :state="!errors.has('user.firstname')"
            aria-describedby="firstnameLiveFeedback"
            placeholder="Prénom"
            data-vv-as="&quot;Prénom&quot;"
            size="lg"
          />
          <b-form-invalid-feedback
            id="firstnameLiveFeedback"
            v-if="errors.has('user.firstname')"
          >{{ errors.first('user.firstname') }}</b-form-invalid-feedback>
        </b-input-group>
      </b-form-group>
      <b-form-group id="lastnameInputGroup">
        <b-input-group>
          <b-input-group-prepend is-text>
            <i class="fa fa-user-circle fa-lg fa-fw"></i>
          </b-input-group-prepend>
          <b-form-input
            id="lastnameInput"
            name="user.lastname"
            type="text"
            maxlength="50"
            v-model.trim="user.lastname"
            v-validate="'required'"
            :state="!errors.has('user.lastname')"
            aria-describedby="lastnameLiveFeedback"
            placeholder="Nom"
            data-vv-as="&quot;Nom&quot;"
            size="lg"
          />
          <b-form-invalid-feedback
            id="lastnameLiveFeedback"
            v-if="errors.has('user.lastname')"
          >{{ errors.first('user.lastname') }}</b-form-invalid-feedback>
        </b-input-group>
      </b-form-group>
      <b-form-group id="emailInputGroup">
        <b-input-group>
          <b-input-group-prepend is-text>
            <i class="fa fa-envelope-o fa-lg fa-fw"></i>
          </b-input-group-prepend>
          <b-form-input
            id="emailInput"
            name="user.email"
            ref="user.email"
            type="email"
            maxlength="255"
            v-model.trim="user.email"
            v-validate="'required|email'"
            :state="!errors.has('user.email')"
            aria-describedby="emailLiveFeedback"
            placeholder="Adresse e-mail"
            data-vv-as="&quot;Adresse e-mail&quot;"
            size="lg"
          />
          <b-form-invalid-feedback
            id="emailLiveFeedback"
            v-if="errors.has('user.email')"
          >{{ errors.first('user.email') }}</b-form-invalid-feedback>
        </b-input-group>
      </b-form-group>
      <b-form-group id="emailConfirmInputGroup">
        <b-input-group>
          <b-input-group-prepend is-text>
            <i class="fa fa-envelope-o fa-lg fa-fw"></i>
          </b-input-group-prepend>
          <b-form-input
            id="emailConfirmInput"
            name="user.emailConfirm"
            type="email"
            maxlength="255"
            v-model.trim="user.emailConfirm"
            v-validate="'required|email|confirmed:user.email'"
            :state="!errors.has('user.emailConfirm')"
            aria-describedby="emailConfirmLiveFeedback"
            placeholder="Confirmation adresse e-mail"
            data-vv-as="&quot;Confirmation adresse e-mail&quot;"
            size="lg"
          />
          <b-form-invalid-feedback
            id="emailConfirmLiveFeedback"
            v-if="errors.has('user.emailConfirm')"
          >{{ errors.first('user.emailConfirm') }}</b-form-invalid-feedback>
        </b-input-group>
      </b-form-group>
      <b-form-group id="passwordInputGroup">
        <b-input-group>
          <b-input-group-prepend is-text>
            <i class="fa fa-key fa-lg fa-fw"></i>
          </b-input-group-prepend>
          <b-form-input
            id="passwordInput"
            name="user.password"
            type="password"
            minlength="8"
            maxlength="255"
            v-model="user.password"
            v-validate="{required: true, min:8}"
            :state="!errors.has('user.password')"
            aria-describedby="passwordLiveFeedback passwordLiveHelp"
            placeholder="Mot de passe"
            data-vv-as="&quot;Mot de passe&quot;"
            size="lg"
          />
          <b-form-invalid-feedback
            id="passwordLiveFeedback"
            v-if="errors.has('user.password')"
          >{{ errors.first('user.password') }}</b-form-invalid-feedback>
        </b-input-group>
        <b-form-text id="passwordLiveHelp">Entrez un mot de passe contenant au minimum 8 caractères.</b-form-text>
      </b-form-group>
      <b-button type="submit" variant="primary" size="lg" :disabled="status.registering">
        Inscription
        <i class="fa fa-user-plus fa-lg fa-fw"></i>
      </b-button>
      <i v-show="status.registering" class="loader fa fa-spinner fa-spin fa-2x"></i>
      <a class="btn btn-block btn-social btn-facebook" @click="authWithFB">
        <span class="fa fa-facebook"></span>
        Inscription avec Facebook
      </a>
      <a class="btn btn-block btn-social btn-google" @click="authWithGoogle">
        <span class="fa fa-google"></span>
        Inscription avec Google
      </a>
    </b-form>
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";

export default {
  name: "UserRegister",
  computed: {
    ...mapState("account", ["status", "user"])
  },
  methods: {
    ...mapActions("account", ["register", "authWithFB", "authWithGoogle"]),
    onSubmit() {
      this.$validator.validateAll().then(valid => {
        if (valid) {
          this.register(this.user);
        }
      });
    }
  }
};
</script>
